export class ConflictError extends Error {
  constructor(message, details) {
    super(message);
    this.name = details?.type || 'ConflictException';
    this.details = details?.detail || message;
    this.statusCode = 409;
  }
}